/* tslint:disable */
/* eslint-disable */
/**
 * TOM OPERATIONS SERVICE API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Configuration } from '../configuration'
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios'
import globalAxios from 'axios'
// Some imports not used depending on template conditions
// @ts-ignore
import {
  DUMMY_BASE_URL,
  assertParamExists,
  setApiKeyToObject,
  setBasicAuthToObject,
  setBearerAuthToObject,
  setOAuthToObject,
  setSearchParams,
  serializeDataIfNeeded,
  toPathString,
  createRequestFunction,
  replaceWithSerializableTypeIfNeeded,
} from '../common'
// @ts-ignore
import {
  BASE_PATH,
  COLLECTION_FORMATS,
  type RequestArgs,
  BaseAPI,
  RequiredError,
  operationServerMap,
} from '../base'
// @ts-ignore
import type { TenantConfigDto } from '../model'
/**
 * TenantConfigsApi - axios parameter creator
 */
export const TenantConfigsApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @param {number} [sourceTenantId]
     * @param {number} [targetTenantId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    copyData: async (
      sourceTenantId?: number,
      targetTenantId?: number,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/operations/api/TenantConfigs/CopyData`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Bearer required
      // oauth required
      await setOAuthToObject(localVarHeaderParameter, 'Bearer', [], configuration)

      if (sourceTenantId !== undefined) {
        localVarQueryParameter['sourceTenantId'] = sourceTenantId
      }

      if (targetTenantId !== undefined) {
        localVarQueryParameter['targetTenantId'] = targetTenantId
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getAll: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
      const localVarPath = `/operations/api/TenantConfigs`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Bearer required
      // oauth required
      await setOAuthToObject(localVarHeaderParameter, 'Bearer', [], configuration)

      localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
  }
}

/**
 * TenantConfigsApi - functional programming interface
 */
export const TenantConfigsApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = TenantConfigsApiAxiosParamCreator(configuration)
  return {
    /**
     *
     * @param {number} [sourceTenantId]
     * @param {number} [targetTenantId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async copyData(
      sourceTenantId?: number,
      targetTenantId?: number,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.copyData(
        sourceTenantId,
        targetTenantId,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['TenantConfigsApi.copyData']?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getAll(
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TenantConfigDto>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getAll(options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['TenantConfigsApi.getAll']?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
  }
}

/**
 * TenantConfigsApi - factory interface
 */
export const TenantConfigsApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = TenantConfigsApiFp(configuration)
  return {
    /**
     *
     * @param {number} [sourceTenantId]
     * @param {number} [targetTenantId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    copyData(
      sourceTenantId?: number,
      targetTenantId?: number,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<void> {
      return localVarFp
        .copyData(sourceTenantId, targetTenantId, options)
        .then(request => request(axios, basePath))
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getAll(options?: RawAxiosRequestConfig): AxiosPromise<TenantConfigDto> {
      return localVarFp.getAll(options).then(request => request(axios, basePath))
    },
  }
}

/**
 * TenantConfigsApi - object-oriented interface
 */
export class TenantConfigsApi extends BaseAPI {
  /**
   *
   * @param {number} [sourceTenantId]
   * @param {number} [targetTenantId]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public copyData(
    sourceTenantId?: number,
    targetTenantId?: number,
    options?: RawAxiosRequestConfig,
  ) {
    return TenantConfigsApiFp(this.configuration)
      .copyData(sourceTenantId, targetTenantId, options)
      .then(request => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public getAll(options?: RawAxiosRequestConfig) {
    return TenantConfigsApiFp(this.configuration)
      .getAll(options)
      .then(request => request(this.axios, this.basePath))
  }
}
